import {PlatformLocation} from '@angular/common';
import {Component, Inject, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {FooterService} from './footer.service';
import {ProductVersion} from 'src/app/core/models';


/**
 * Display the footer.
 */
@UntilDestroy()
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit, OnDestroy {
  public currentVersion: ProductVersion;
  public currentLocale: string;
  public hostURL: any = `${location.protocol}//${location.host}`;
  public hostPath: any = '';
  public currentBaseHref: any;
  public locales: Array<string> = ['en', 'de', 'es'];

  constructor(
    private browserLocation: PlatformLocation,
    public route: ActivatedRoute,
    public footerService: FooterService,
    @Inject(LOCALE_ID) public locale: any
  ) {
    this.currentBaseHref = this.browserLocation.getBaseHrefFromDOM();
    this.footerService.castCurrentVersioning
      .pipe(untilDestroyed(this))
      .subscribe((data: ProductVersion) => this.currentVersion = data);
    if (locale === 'en-US') {
      this.currentLocale = 'en';
    } else {
      this.currentLocale = locale;
    }
    this.setHostPath();
  }

  public ngOnInit(): void {
    if (this.currentVersion === null) {
      this.footerService.get()
        .pipe(untilDestroyed(this))
        .subscribe((data: ProductVersion) => {
          this.footerService.setCurrentVersioning(data);
        });
    }
  }

  public ngOnDestroy(): void { }

  public setHostPath(): void {
    const path = location.pathname.split('/');
    path.splice(0, 2);
    this.hostPath = path.join('/');
  }
}
